let hamburger = document.querySelector(".hamburger");
let navListContainer = document.querySelector(".nav__list-container");
let header = document.getElementById("nav");
hamburger.onclick = ()=>{
    hamburger.classList.toggle("is-active");
    navListContainer.classList.toggle("nav__list-container--open");
    header.classList.toggle("open");
};

//# sourceMappingURL=index.09e3c66b.js.map
